<ng-template #modal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Coberturas</h4>
      <button type="button" class="btn-close focus-ring focus-ring-dark" ria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div ngbAccordion>
            @for ( coverage of coverages; track $index){
            <div ngbAccordionItem >
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="btn btn-light focus-ring-dark focus-ring bg-white">
                        <span class="mx-2">{{coverage.name}} </span>
                        <small>Valor del riesgo ${{coverage.riskValue | number: '1.0-0'}}</small>
                    </button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            {{coverage.description}}
                        </ng-template>
                    </div>
                </div>
            </div>
            }
        </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss('Cross click')">Cerrar</button>
    </div>
</ng-template>
